import "./Sidebar.scss";

import React, { useContext } from "react";

import { AbilityContext } from "../../config/Can";
import DropdownButton from "../common/ButtonDropDown/ButtonDropDown";
import { IDropdownButtonList } from "../../interfaces/Index";
import Link from "./Link/Link";
import ROUTES from "../../config/RouteNames";
import IconOrder from "assets/images/icn_orders.svg";
import IconCustomer from "./assets/images/icn_customers.svg";
import IconProducts from "../../assets/images/icn_products.svg";
import configurationIcon from "../../assets/images/gear_icn.svg";
import IconCategories from "assets/images/icn_categories.svg";
import IconAccessControl from "assets/images/icn_access_control.svg";
import IconPromos from "assets/images/promo.svg";
import IconPoints from "assets/images/icn_points.svg";
import IconAgents from "assets/images/icn_agents.svg";
import IconCampaign from "assets/images/icn_campaign.svg";
import IconRider from "assets/images/icn_riders.svg";
import IconCard from "assets/images/icn_card.svg";
import BazaarLogo from "assets/bazaar-logo.svg";
import IconWarehouseStaff from "assets/images/icon_warehouse_staff.svg";
import { getFromLocal } from "../../utils/Cache";
import { LOCAL_STORAGE_KEYS } from "../../config/constants";
import { authInitialState } from "../../redux/reducers/InitialState";

const SideBar = (props: any) => {
  const ability = useContext(AbilityContext);
  const { path } = props;
  const navItem = [
    // {
    //   id: "orders",
    //   name: "Orders",
    //   url: ROUTES.DASHBOARD_ORDER,
    //   isActive: path.pathname === ROUTES.DASHBOARD_ORDER,
    //   childNav: [],
    //   img: IconOrder,
    //   isEnable: ability.can("read", "order"),
    // },
    // {
    //   id: "customers",
    //   name: "Customers",
    //   url: ROUTES.DASHBOARD_CUSTOMER,
    //   isActive: path.pathname === ROUTES.DASHBOARD_CUSTOMER,
    //   childNav: [],
    //   img: IconCustomer,
    //   isEnable: ability.can("read", "user"),
    // },
    {
      id: "catalogue",
      name: "Catalogue",
      url: "",
      img: IconProducts,

      childNav: [
        {
          id: "products",
          name: "Products",
          url: ROUTES.DASHBOARD_PRODUCT_CITY_LEVEL,
          isActive: path.pathname === ROUTES.DASHBOARD_PRODUCT_CITY_LEVEL,
          img: IconProducts,
          isEnable: ability.can("read", "product"),
        },
        {
          id: "categories",
          name: "Categories",
          url: ROUTES.DASHBOARD_CATEGORY_CITY_LEVEL,
          isActive: path.pathname === ROUTES.DASHBOARD_CATEGORY_CITY_LEVEL,
          img: IconCategories,
          isEnable: ability.can("read", "category"),
        },
        {
          id: "banners",
          name: "Banners",
          url: ROUTES.DASHBOARD_BANNERS,
          isActive: path.pathname === ROUTES.DASHBOARD_BANNERS,
          img: "",
          isEnable: ability.can("read", "banner"),
        },
      ],
    },
    {
      id: "accessControl",
      name: "Access Control",
      url: ROUTES.DASHBOARD_ACCESS_CONTROL,
      isActive: path.pathname === ROUTES.DASHBOARD_ACCESS_CONTROL,
      childNav: [],
      img: IconAccessControl,
      isEnable: ability.can("read", "access"),
    },
    {
      id: "promos",
      name: "Promos",
      url: ROUTES.DASHBOARD_PROMOS_CITY_LEVEL,
      isActive: path.pathname === ROUTES.DASHBOARD_PROMOS_CITY_LEVEL,
      childNav: [],
      img: IconPromos,
      isEnable: ability.can("read", "promo"),
    },
    {
      id: "newsfeedConfig",
      name: "Newsfeed Config",
      url: ROUTES.DASHBOARD_NEWSFEED,
      isActive: path.pathname === ROUTES.DASHBOARD_NEWSFEED,
      childNav: [],
      img: IconWarehouseStaff,
      isEnable: ability.can("read", "post") || ability.can("*", "post"),
    },
    {
      id: "topUp",
      name: "Top Up",
      url: ROUTES.DASHBOARD_TOPUP,
      isActive: path.pathname === ROUTES.DASHBOARD_TOPUP,
      childNav: [],
      img: IconPoints,
      isEnable: ability.can("create", "topup"),
    },
    {
      id: "CnicVerification",
      name: "Cnic Verification",
      url: ROUTES.DASHBOARD_CNIC_VERIFICATION,
      isActive: path.pathname === ROUTES.DASHBOARD_CNIC_VERIFICATION,
      childNav: [],
      img: IconCard,
      isEnable: ability.can("read", "nationalid"),
    },
    {
      id: "agents",
      name: "Agents",
      url: "",
      img: IconAgents,
      childNav: [
        {
          id: "agentManagement",
          name: "Management",
          url: ROUTES.DASHBOARD_AGENT_MANAGEMENT,
          isActive: path.pathname === ROUTES.DASHBOARD_AGENT_MANAGEMENT,
          img: IconProducts,
          isEnable:
            ability.can("*", "agent") ||
            ability.can("create", "agent") ||
            ability.can("update", "agent") ||
            ability.can("read", "agent"),
        },
        {
          id: "agentAssignment",
          name: "Assignment",
          url: ROUTES.DASHBOARD_AGENT_ASSIGNMENT,
          isActive: path.pathname === ROUTES.DASHBOARD_AGENT_ASSIGNMENT,
          img: IconProducts,
          isEnable:
            ability.can("create", "criteria") || ability.can("read", "product"),
        },
        // {
        //   id: "storeListing",
        //   name: "Store listing",
        //   url: ROUTES.DASHBOARD_STORE_LISTING,
        //   isActive: path.pathname === ROUTES.DASHBOARD_STORE_LISTING,
        //   img: IconProducts,
        //   isEnable: ability.can("read", "product"),
        // },
        {
          id: "metrics",
          name: "Metrics",
          url: ROUTES.DASHBOARD_METRICS,
          isActive: path.pathname === ROUTES.DASHBOARD_METRICS,
          img: IconProducts,
          isEnable: ability.can("*", "agent"),
        },
      ],
    },
    {
      id: "riders",
      name: "Riders",
      url: "",
      img: IconRider,
      childNav: [
        {
          id: "tourAssignment",
          name: "Tour Assignment",
          url: ROUTES.DASHBOARD_TOUR_ASSIGNMENT,
          isActive: path.pathname === ROUTES.DASHBOARD_TOUR_ASSIGNMENT,
          img: "",
          isEnable: ability.can("update", "tour"),
        },
        {
          id: "shiftDetails",
          name: "Shift details",
          url: ROUTES.DASHBOARD_SHIFT_DETAIL,
          isActive: path.pathname === ROUTES.DASHBOARD_SHIFT_DETAIL,
          img: "",
          isEnable: ability.can("read", "shift"),
        },
        {
          id: "tourCreation",
          name: "3rd party logistics",
          url: ROUTES.DASHBOARD_TOUR_CREATION,
          isActive: path.pathname === ROUTES.DASHBOARD_TOUR_CREATION,
          img: "",
          isEnable: ability.can("create", "plan"),
        },
        {
          id: "batchSelection",
          name: "Batch Selection",
          url: ROUTES.DASHBOARD_PLAN_ASSIGNMENT,
          isActive: path.pathname === ROUTES.DASHBOARD_PLAN_ASSIGNMENT,
          img: "",
          isEnable: ability.can("create", "access"),
        },
        {
          id: "riderManagement",
          name: "Management",
          url: ROUTES.DASHBOARD_RIDER_MANAGEMENT,
          isActive: path.pathname === ROUTES.DASHBOARD_RIDER_MANAGEMENT,
          img: "",
          isEnable: ability.can("create", "rider"),
        },
        {
          id: "planCreation",
          name: "Plan Creation",
          url: ROUTES.DASHBOARD_PLAN_CREATION,
          isActive: path.pathname === ROUTES.DASHBOARD_PLAN_CREATION,
          img: "",
          isEnable: ability.can("create", "plan"),
        },
      ],
    },
    {
      id: "configurations",
      name: "Configurations",
      url: "",
      img: configurationIcon,
      childNav: [
        {
          id: "global_products",
          name: "Products",
          url: ROUTES.DASHBOARD_GLOBAL_PRODUCT,
          isActive: path.pathname === ROUTES.DASHBOARD_GLOBAL_PRODUCT,
          img: IconProducts,
          /* TODO: Will be cleaned on Global product Cleanup */
          isEnable: false,
        },
        {
          id: "categories",
          name: "Categories",
          url: ROUTES.DASHBOARD_CATEGORY_GLOBAL,
          isActive: path.pathname === ROUTES.DASHBOARD_CATEGORY_GLOBAL,
          img: IconProducts,
          isEnable: ability.can("read", "category"),
        },
        {
          id: "zonalConfig",
          name: "Zonal Config",
          url: ROUTES.DASHBOARD_ZONAL_CONFIG,
          isActive: path.pathname === ROUTES.DASHBOARD_ZONAL_CONFIG,
          img: IconPromos,
          isEnable: ability.can("read", "zone"),
        },
        {
          id: "deliveryDate",
          name: "Delivery Date",
          url: ROUTES.DASHBOARD_DELIVERY_DATE,
          isActive: path.pathname === ROUTES.DASHBOARD_DELIVERY_DATE,
          img: "",
          isEnable: ability.can("read", "warehouse"),
        },
        {
          id: "liveOps",
          name: "Live Ops",
          url: ROUTES.DASHBOARD_LIVEOPS,
          isActive: path.pathname === ROUTES.DASHBOARD_LIVEOPS,
          img: "",
          isEnable: ability.can("update", "tour"),
        },
      ],
    },
    {
      id: "camapaigns",
      name: "Campaigns",
      url: "",
      img: IconCampaign,
      childNav: [
        {
          id: "camapaigns",
          name: "Inaam Bazaar",
          url: ROUTES.DASHBOARD_CAMPAIGN,
          isActive: path.pathname === ROUTES.DASHBOARD_CAMPAIGN,
          img: IconCampaign,
          isEnable: ability.can("read", "campaign"),
        },
        {
          id: "paiyaConfig",
          name: "Paiya",
          url: ROUTES.DASHBOARD_PAIYA,
          isActive: path.pathname === ROUTES.DASHBOARD_PAIYA,
          childNav: [],
          img: "",
          isEnable: ability.can("read", "config") || ability.can("*", "game"),
        },
        {
          id: "paiyaConfig",
          name: "Paiya Gifts",
          url: ROUTES.DASHBOARD_PAIYA_GIFTS,
          isActive: path.pathname === ROUTES.DASHBOARD_PAIYA_GIFTS,
          childNav: [],
          img: "",
          isEnable: ability.can("read", "config") || ability.can("*", "game"),
        },
      ],
    },

    // disabled warehouse staff update support as its moved to nucleus WMS.
    // {
    //   id: "warehouse",
    //   name: "Warehouse staff",
    //   url: ROUTES.DASHBOARD_WAREHOUSE_STAFF,
    //   isActive: path.pathname === ROUTES.DASHBOARD_WAREHOUSE_STAFF,
    //   childNav: [],
    //   img: IconWarehouseStaff,
    //   isEnable: ability.can("read", "staff"),
    // },
  ];

  const navItemList = navItem.map((item) => (
    <Link
      key={item.id}
      name={item.name}
      isActive={item.isActive}
      url={item.url}
      img={item.img}
      childNav={item.childNav}
      isEnable={!item.isEnable}
    />
  ));

  const logout = () => {
    let confirmMsg = window.confirm("Are you sure you want to Logout");
    if (confirmMsg) {
      localStorage.clear();
      window.location.reload();
    }
  };
  const list: Array<IDropdownButtonList> = [
    { id: 1, buttonName: "Logout", clickHandler: logout },
  ];
  const initials = () => {
    let fullName = getNameFromLocalStorage().trim();
    let subString = fullName.split(" ");
    let initial1 = subString[0].split("");
    if (subString[1]) {
      let initial2 = subString[1].split("");
      let nameInitials = initial1[0].concat(initial2[0]) || "";
      return nameInitials;
    }
    return initial1[0];
  };

  const getNameFromLocalStorage = () => {
    let userAuth = authInitialState;
    if (LOCAL_STORAGE_KEYS.auth) {
      userAuth = Object.assign(
        {},
        userAuth,
        getFromLocal(LOCAL_STORAGE_KEYS.auth)
      );
    }
    return userAuth.userInfo?.fullName || "Commando commander";
  };

  return (
    <div className="sidebar-container scroll-bar">
      <div className="logo-container">
        <a href="/">
          <img src={BazaarLogo} alt="Bazaar" title="Bazaar" />
        </a>
      </div>
      <div className="link-container">
        <ul className="scroll-bar">{navItemList}</ul>
      </div>
      <footer className="footer">
        <div className="local-icon" title={getNameFromLocalStorage()}>
          {initials()}
        </div>

        <DropdownButton
          classNames="dropdown"
          dropDownButtonText={getNameFromLocalStorage()}
          dropdownItem={list}
        />
      </footer>
    </div>
  );
};

export default SideBar;
